module.exports = __webpack_public_path__ + "img/wxpay.e270e2b7.png";